import { useState, useEffect } from 'react';
import { api } from '../api';

const CATEGORIAS = ['filtros', 'galones', 'litros', 'canecas', 'varios'];
const ESTADO_STYLE = {
  ok:       { bg: '#1a3a2a', color: '#4caf50', label: '✅ OK' },
  faltante: { bg: '#3a1a1a', color: '#e63946', label: '❌ Faltante' },
  exceso:   { bg: '#3a3a1a', color: '#ffc107', label: '⚠️ Exceso' },
};


const fmt  = (n) => (n || 0).toLocaleString('es-EC', { minimumFractionDigits: 2 });
const fmtN = (n) => { const v = n || 0; return (v < 0 ? '-' : '') + '$' + Math.abs(v).toLocaleString('es-EC', { minimumFractionDigits: 2 }); };

// ═══════════════════════════════════════════════════════════════════
// TAB: Estado BOD. ESTACION
// ═══════════════════════════════════════════════════════════════════
function EstadoBodega() {
  const [datos,    setDatos]    = useState(null);
  const [cargando, setCargando] = useState(true);
  const [vistaTab, setVistaTab] = useState('negativos');
  const [busq,     setBusq]     = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const data = await api.get('/bodegas/estado-principal');
      setDatos(data.error ? null : data);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  if (cargando) return <p style={{ color: '#aaa', padding: 40, textAlign: 'center' }}>Cargando estado de bodega...</p>;
  if (!datos)   return <p style={{ color: '#e63946', padding: 20 }}>Error cargando datos</p>;

  const k = datos.kpis;
  const itemsFiltrados = (vistaTab === 'negativos' ? datos.negativos : datos.top_valor)
    .filter(i => !busq ||
      i.item.toUpperCase().includes(busq.toUpperCase()) ||
      i.codigo_bar.includes(busq) ||
      i.marca.toUpperCase().includes(busq.toUpperCase())
    );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h2 style={{ color: '#fff', marginBottom: 4 }}>🏭 BOD. ESTACION — Estado actual</h2>
          <p style={{ color: '#555', fontSize: 13 }}>Bodega principal · costo real de última factura de compra</p>
        </div>
        <button style={s.botonHistorial} onClick={cargar}>🔄 Actualizar</button>
      </div>

      <div style={s.kpisRow}>
        {[
          ['Valor total',     fmtN(k.valor_total),   k.valor_total >= 0 ? '#4cc9f0' : '#e63946', '#7209b7'],
          ['Items positivos', k.items_positivos,      '#4caf50', '#4caf50'],
          ['Items negativos', k.items_negativos,      k.items_negativos > 0 ? '#e63946' : '#4caf50', k.items_negativos > 0 ? '#e63946' : '#4caf50'],
          ['Items en cero',   k.items_cero,           '#ffc107', '#ffc107'],
          ['Valor negativo',  fmtN(k.valor_negativo), '#e63946', '#e63946'],
        ].map(([label, val, color, border]) => (
          <div key={label} style={{ ...s.kpiCard, borderTopColor: border }}>
            <div style={{ ...s.kpiValor, color, fontSize: 20 }}>{val}</div>
            <div style={s.kpiLabel}>{label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[
          { key: 'negativos', label: `🔴 Stock negativo (${datos.negativos.length})` },
          { key: 'top_valor', label: '💰 Top 25 por valor' },
        ].map(t => (
          <button key={t.key}
            style={{
              padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 'bold',
              background: vistaTab === t.key ? '#1a2a3e' : 'none',
              border: vistaTab === t.key ? '1px solid #4cc9f0' : '1px solid #2d2d44',
              color: vistaTab === t.key ? '#4cc9f0' : '#888',
            }}
            onClick={() => { setVistaTab(t.key); setBusq(''); }}>
            {t.label}
          </button>
        ))}
        <input
          style={{ flex: 1, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '8px 14px', fontSize: 13 }}
          placeholder="Buscar producto, código o marca..."
          value={busq}
          onChange={e => setBusq(e.target.value)}
        />
      </div>

      <div style={s.conteoTabla}>
        <div style={{ ...s.conteoHeader, gap: 8 }}>
          <span style={{ flex: 4 }}>PRODUCTO</span>
          <span style={{ width: 90,  textAlign: 'right' }}>STOCK</span>
          <span style={{ width: 100, textAlign: 'right' }}>COSTO U.</span>
          <span style={{ width: 120, textAlign: 'right' }}>VALOR</span>
        </div>
        <div style={{ maxHeight: 'calc(100vh - 440px)', overflowY: 'auto' }}>
          {itemsFiltrados.length === 0 ? (
            <p style={{ color: '#555', textAlign: 'center', padding: 32 }}>
              {vistaTab === 'negativos' ? '✅ Sin items con stock negativo' : 'Sin resultados'}
            </p>
          ) : itemsFiltrados.map((item, i) => (
            <div key={item.codigo_bar + i} style={{
              ...s.conteoRow,
              background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e',
              borderLeft: `3px solid ${item.stock < 0 ? '#e63946' : '#4caf50'}`,
              gap: 8,
            }}>
              <span style={{ flex: 4 }}>
                <div style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>{item.item}</div>
                <div style={{ color: '#555', fontSize: 11 }}>{item.codigo_bar} · {item.marca}</div>
              </span>
              <span style={{ width: 90, textAlign: 'right', fontWeight: 'bold', fontSize: 14, color: item.stock < 0 ? '#e63946' : '#4caf50' }}>
                {item.stock > 0 ? '+' : ''}{item.stock.toFixed(0)}
              </span>
              <span style={{ width: 100, textAlign: 'right', color: '#aaa', fontSize: 12 }}>
                ${item.costo.toFixed(2)}
              </span>
              <span style={{ width: 120, textAlign: 'right', fontWeight: 'bold', fontSize: 13, color: item.valor < 0 ? '#e63946' : '#4caf50' }}>
                {fmtN(item.valor)}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 16px', borderTop: '1px solid #2d2d44', marginTop: 4 }}>
        <span style={{ color: '#aaa', fontSize: 13 }}>
          {itemsFiltrados.length} items · Total:{' '}
          <strong style={{ color: itemsFiltrados.reduce((a,i) => a + i.valor, 0) < 0 ? '#e63946' : '#4caf50' }}>
            {fmtN(itemsFiltrados.reduce((a, i) => a + i.valor, 0))}
          </strong>
        </span>
      </div>
    </div>
  );
}

function ConteoAuditoria() {
  const [paso, setPaso] = useState('inicio'); // inicio | conteo | reporte | historial
  const [tipo, setTipo] = useState('aleatorio');
  const [filtro, setFiltro] = useState('');
  const [cantidad, setCantidad] = useState(25);
  const [marcas, setMarcas] = useState([]);
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [historial,      setHistorial]      = useState([]);
  const [historialTotal, setHistorialTotal] = useState(0);
  const [historialPag,   setHistorialPag]   = useState(1);
  const [busqHistorial,  setBusqHistorial]  = useState('');
  const [revisando,      setRevisando]      = useState(null); // id auditoria procesando
  const HIST_LIMIT = 25;
  const [auditoriaDetalle, setAuditoriaDetalle] = useState(null);
  const [auditoriaGuardada, setAuditoriaGuardada] = useState(null);

  // Selección por elección
  const [modoEleccion, setModoEleccion]       = useState(false);
  const [itemsMarca, setItemsMarca]           = useState([]);    // todos los items de la marca
  const [itemsSelec, setItemsSelec]           = useState({});    // {codigo: true/false}
  const [cargandoMarca, setCargandoMarca]     = useState(false);
  const [busqEleccion, setBusqEleccion]       = useState('');

  useEffect(() => { cargarMarcas(); }, []);

  const cargarMarcas = async () => {
    try {
      const data = await api.get('/inventario/marcas');
      setMarcas(data.marcas || []);
    } catch (e) { console.error(e); }
  };

  const cargarItemsMarca = async (marca) => {
    if (!marca) { setItemsMarca([]); setItemsSelec({}); return; }
    setCargandoMarca(true);
    try {
      const data = await api.get(`/auditoria/items-marca?marca=${encodeURIComponent(marca)}`);
      setItemsMarca(data.items || []);
      // Seleccionar todos por defecto
      const sel = {};
      (data.items || []).forEach(i => { sel[i.codigo] = true; });
      setItemsSelec(sel);
    } catch(e) { console.error(e); }
    finally { setCargandoMarca(false); }
  };

  const toggleItem = (codigo) => {
    setItemsSelec(prev => ({ ...prev, [codigo]: !prev[codigo] }));
  };

  const toggleTodos = () => {
    const todos = Object.values(itemsSelec).every(v => v);
    const sel = {};
    itemsMarca.forEach(i => { sel[i.codigo] = !todos; });
    setItemsSelec(sel);
  };

  const generarConteo = async () => {
    if (tipo !== 'aleatorio' && !filtro) {
      alert('Selecciona un filtro');
      return;
    }
    // Modo por elección: usar items seleccionados directamente
    if (modoEleccion) {
      const seleccionados = itemsMarca.filter(i => itemsSelec[i.codigo]);
      if (seleccionados.length === 0) { alert('Selecciona al menos un item'); return; }
      setItems(seleccionados.map(i => ({ ...i, stock_fisico: '' })));
      setPaso('conteo');
      return;
    }

    setCargando(true);
    try {
      const params = `tipo=${tipo}&filtro=${encodeURIComponent(filtro)}&cantidad=${cantidad}`;
      const data = await api.get(`/auditoria/generar?${params}`);
      if (data.error) { alert(data.error); return; }
      setItems(data.items.map(i => ({ ...i, stock_fisico: '' })));
      setPaso('conteo');
    } catch (e) { alert('Error generando conteo'); }
    finally { setCargando(false); }
  };

  const actualizarFisico = (idx, valor) => {
    setItems(items.map((item, i) => i === idx ? { ...item, stock_fisico: valor } : item));
  };

  const todoIngresado = items.every(i => i.stock_fisico !== '' && i.stock_fisico !== null);

  const calcularDiferencia = (item) => {
    const fisico = parseFloat(item.stock_fisico);
    if (isNaN(fisico)) return null;
    return fisico - item.stock_sistema;
  };

  const procesarReporte = () => {
    const procesados = items.map(item => {
      const diff = calcularDiferencia(item);
      return {
        ...item,
        stock_fisico: parseFloat(item.stock_fisico),
        diferencia: diff,
        estado: diff === 0 ? 'ok' : diff < 0 ? 'faltante' : 'exceso'
      };
    });
    setItems(procesados);
    setPaso('reporte');
  };

  const guardarAuditoria = async () => {
    setCargando(true);
    try {
      const data = await api.post('/auditoria/guardar', {
        tipo, filtro, items, creado_por: 'admin'
      });
      setAuditoriaGuardada(data.auditoria_id);
      alert(`Auditoría #${data.auditoria_id} guardada correctamente`);
    } catch (e) { alert('Error guardando auditoría'); }
    finally { setCargando(false); }
  };

  const marcarRevisado = async (id, valor) => {
    setRevisando(id);
    try {
      await api.patch(`/auditoria/${id}/revisado`, { revisado: valor, revisado_por: 'admin' });
      setHistorial(prev => prev.map(a =>
        a.id === id ? { ...a, revisado: valor } : a
      ));
    } catch(e) { alert('Error al actualizar'); }
    finally { setRevisando(null); }
  };

  const cargarHistorial = async (pagina = 1) => {
    setCargando(true);
    try {
      const data = await api.get(
        `/auditoria/historial?page=${pagina}&limit=${HIST_LIMIT}`
      );
      setHistorial(data.auditorias || []);
      setHistorialTotal(data.total || (data.auditorias || []).length);
      setHistorialPag(pagina);
      setPaso('historial');
    } catch (e) { alert('Error cargando historial'); }
    finally { setCargando(false); }
  };

  const verDetalle = async (id) => {
    setCargando(true);
    try {
      const data = await api.get(`/auditoria/${id}`);
      setAuditoriaDetalle(data);
    } catch (e) { alert('Error cargando detalle'); }
    finally { setCargando(false); }
  };

  const imprimirConteo = () => {
    const fecha = new Date().toLocaleDateString('es-EC');
    const hora = new Date().toLocaleTimeString('es-EC');
    const html = `
    <html><head><meta charset="UTF-8">
    <style>
        * { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
        h1 { font-size:18px; color:#1a1a2e; margin-bottom:4px; }
        .sub { color:#888; font-size:11px; margin-bottom:20px; }
        table { width:100%; border-collapse:collapse; }
        th { background:#1a1a2e; color:#fff; padding:8px 10px; font-size:11px; text-align:left; }
        td { padding:8px 10px; border-bottom:1px solid #ddd; font-size:12px; }
        .fisico-col { width:80px; border:1px solid #999; border-radius:4px; height:28px; }
        .num { color:#888; font-size:10px; text-align:center; width:30px; }
    </style></head>
    <body>
        <h1>🔍 Lista de Conteo Físico — Zoler Trading</h1>
        <div class="sub">
        Fecha: ${fecha} ${hora} · 
        Tipo: ${tipo} ${filtro ? '· Filtro: ' + filtro : ''} · 
        Total items: ${items.length}
        </div>
        <table>
        <tr>
            <th class="num">#</th>
            <th style="width:80px">Código</th>
            <th>Descripción</th>
            <th style="width:80px">Marca</th>
            <th style="width:90px;text-align:right">Sistema</th>
            <th style="width:100px;text-align:center">Físico</th>
            <th style="width:60px;text-align:center">✓</th>
        </tr>
        ${items.map((item, i) => `
            <tr>
            <td class="num">${i + 1}</td>
            <td style="color:#555;font-size:11px">${item.codigo_bar || item.codigo}</td>
            <td>${item.descripcion}</td>
            <td>${item.marca}</td>
            <td style="text-align:right;font-weight:bold;color:#1a1a2e">${item.stock_sistema}</td>
            <td style="text-align:center"><div class="fisico-col"></div></td>
            <td style="text-align:center">☐</td>
            </tr>`).join('')}
        </table>
        <div style="margin-top:20px;font-size:10px;color:#aaa;">
        Firmado por: _________________________________ Fecha: _____________
        </div>
    </body></html>`;

    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
    };

  const imprimirReporte = (auditData, auditItems) => {
    const fecha = new Date().toLocaleDateString('es-EC');
    const ok = auditItems.filter(i => i.estado === 'ok').length;
    const faltantes = auditItems.filter(i => i.estado === 'faltante');
    const excesos = auditItems.filter(i => i.estado === 'exceso');
    const totalFaltante = faltantes.reduce((a, i) => a + Math.abs(i.diferencia), 0);

    const html = `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:20px; font-size:12px; }
      h1 { font-size:18px; color:#1a1a2e; margin-bottom:4px; }
      .sub { color:#888; font-size:11px; margin-bottom:20px; }
      .kpis { display:flex; gap:16px; margin-bottom:20px; }
      .kpi { border:1px solid #ddd; border-radius:6px; padding:12px 16px; flex:1; text-align:center; }
      .kpi-num { font-size:24px; font-weight:bold; }
      .kpi-label { font-size:10px; color:#888; margin-top:2px; }
      .ok { color:#2e7d32; } .faltante { color:#c62828; } .exceso { color:#f57f17; }
      table { width:100%; border-collapse:collapse; margin-top:12px; }
      th { background:#1a1a2e; color:#fff; padding:6px 8px; font-size:11px; text-align:left; }
      td { padding:6px 8px; border-bottom:1px solid #eee; font-size:11px; }
      .row-faltante { background:#fff5f5; }
      .row-exceso { background:#fffbf0; }
      .seccion { font-weight:bold; color:#1a1a2e; margin:16px 0 8px; font-size:13px; border-bottom:2px solid #1a1a2e; padding-bottom:4px; }
    </style></head>
    <body>
      <h1>🔍 Reporte de Auditoría de Inventario</h1>
      <div class="sub">Fecha: ${fecha} · Tipo: ${auditData?.tipo || tipo} ${auditData?.filtro || filtro ? '· Filtro: ' + (auditData?.filtro || filtro) : ''} · Total items: ${auditItems.length}</div>
      <div class="kpis">
        <div class="kpi"><div class="kpi-num ok">${ok}</div><div class="kpi-label">Sin diferencia</div></div>
        <div class="kpi"><div class="kpi-num faltante">${faltantes.length}</div><div class="kpi-label">Con faltante</div></div>
        <div class="kpi"><div class="kpi-num exceso">${excesos.length}</div><div class="kpi-label">Con exceso</div></div>
        <div class="kpi"><div class="kpi-num faltante">${totalFaltante.toFixed(0)}</div><div class="kpi-label">Unidades faltantes</div></div>
      </div>
      ${faltantes.length > 0 ? `
      <div class="seccion">❌ Items con Faltante</div>
      <table>
        <tr><th>Código</th><th>Descripción</th><th>Marca</th><th>Sistema</th><th>Físico</th><th>Diferencia</th></tr>
        ${faltantes.map(i => `
          <tr class="row-faltante">
            <td>${i.codigo_bar || i.codigo}</td><td>${i.descripcion}</td><td>${i.marca}</td>
            <td>${i.stock_sistema}</td><td>${i.stock_fisico}</td>
            <td style="color:#c62828;font-weight:bold">${i.diferencia}</td>
          </tr>`).join('')}
      </table>` : ''}
      ${excesos.length > 0 ? `
      <div class="seccion">⚠️ Items con Exceso</div>
      <table>
        <tr><th>Código</th><th>Descripción</th><th>Marca</th><th>Sistema</th><th>Físico</th><th>Diferencia</th></tr>
        ${excesos.map(i => `
          <tr class="row-exceso">
            <td>${i.codigo_bar || i.codigo}</td><td>${i.descripcion}</td><td>${i.marca}</td>
            <td>${i.stock_sistema}</td><td>${i.stock_fisico}</td>
            <td style="color:#f57f17;font-weight:bold">+${i.diferencia}</td>
          </tr>`).join('')}
      </table>` : ''}
      <div class="seccion">✅ Items sin Diferencia</div>
      <table>
        <tr><th>Código</th><th>Descripción</th><th>Marca</th><th>Stock</th></tr>
        ${auditItems.filter(i => i.estado === 'ok').map(i => `
          <tr><td>${i.codigo_bar || i.codigo}</td><td>${i.descripcion}</td><td>${i.marca}</td><td>${i.stock_sistema}</td></tr>`).join('')}
      </table>
    </body></html>`;

    const ventana = window.open('', '_blank', 'width=900,height=700');
    ventana.document.write(html);
    ventana.document.close();
    ventana.onload = () => { ventana.focus(); ventana.print(); };
  };

  const reiniciar = () => {
    setModoEleccion(false); setItemsMarca([]); setItemsSelec({}); setBusqEleccion('');
    setPaso('inicio');
    setItems([]);
    setAuditoriaGuardada(null);
    setAuditoriaDetalle(null);
    setFiltro('');
  };

  // ─── VISTA: INICIO ───
  if (paso === 'inicio') return (
    <div>
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>🔍 Conteo Cíclico</h2>
          <p style={s.subtitulo}>Auditoría de inventario físico vs sistema</p>
        </div>
        <button style={s.botonHistorial} onClick={() => cargarHistorial(1)}>📋 Ver historial</button>
      </div>

      <div style={s.configCard}>
        <h3 style={s.configTitulo}>Configurar conteo</h3>

        {/* Tipo */}
        <div style={s.campo}>
          <label style={s.label}>Tipo de selección</label>
          <div style={s.tipoRow}>
            {['aleatorio', 'marca', 'categoria'].map(t => (
              <button key={t} style={{...s.tipoBton, ...(tipo === t ? s.tipoBtonActivo : {})}}
                onClick={() => { setTipo(t); setFiltro(''); setModoEleccion(false); setItemsMarca([]); setItemsSelec({}); setBusqEleccion(''); }}>
                {t === 'aleatorio' ? '🎲 Aleatorio' : t === 'marca' ? '🏷️ Por marca' : '📦 Por categoría'}
              </button>
            ))}
          </div>
        </div>

        {/* Filtro por marca */}
        {tipo === 'marca' && (
          <div style={s.campo}>
            <label style={s.label}>Selecciona la marca</label>
            <select style={s.select} value={filtro} onChange={e => { setFiltro(e.target.value); if (modoEleccion) cargarItemsMarca(e.target.value); }}>
              <option value="">-- Seleccionar --</option>
              {marcas.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        )}

        {/* Filtro por categoría */}
        {tipo === 'categoria' && (
          <div style={s.campo}>
            <label style={s.label}>Selecciona la categoría</label>
            <div style={s.tipoRow}>
              {CATEGORIAS.map(c => (
                <button key={c} style={{...s.tipoBton, ...(filtro === c ? s.tipoBtonActivo : {})}}
                  onClick={() => setFiltro(c)}>
                  {c.charAt(0).toUpperCase() + c.slice(1)}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Cantidad */}
        {!modoEleccion && (
          <div style={s.campo}>
            <label style={s.label}>Cantidad de items a contar</label>
            <div style={s.cantidadRow}>
              {[10, 25, 50, 100].map(n => (
                <button key={n} style={{...s.tipoBton, ...(cantidad === n ? s.tipoBtonActivo : {})}}
                  onClick={() => setCantidad(n)}>
                  {n} items
                </button>
              ))}
              {tipo === 'marca' && filtro && (
                <button style={{...s.tipoBton, borderColor: '#ffc107', color: '#ffc107'}}
                  onClick={() => { setModoEleccion(true); cargarItemsMarca(filtro); }}>
                  ✋ Por elección
                </button>
              )}
            </div>
          </div>
        )}

        {/* Selector por elección */}
        {modoEleccion && (
          <div style={s.campo}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <label style={s.label}>
                Selecciona items de <strong style={{ color: '#4cc9f0' }}>{filtro}</strong>
                {' · '}{Object.values(itemsSelec).filter(Boolean).length} seleccionados
              </label>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={{ ...s.tipoBton, fontSize: 11 }} onClick={toggleTodos}>
                  {Object.values(itemsSelec).every(Boolean) ? 'Deseleccionar todo' : 'Seleccionar todo'}
                </button>
                <button style={{ ...s.tipoBton, fontSize: 11, color: '#e63946', borderColor: '#e63946' }}
                  onClick={() => { setModoEleccion(false); setItemsMarca([]); setItemsSelec({}); setBusqEleccion(''); }}>
                  ✕ Cancelar
                </button>
              </div>
            </div>
            <input
              value={busqEleccion}
              onChange={e => setBusqEleccion(e.target.value)}
              placeholder="Buscar item..."
              style={{ width: '100%', background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '8px 12px', fontSize: 13, marginBottom: 10, boxSizing: 'border-box' }}
            />
            {cargandoMarca ? (
              <p style={{ color: '#aaa', fontSize: 13 }}>Cargando items...</p>
            ) : (
              <div style={{ maxHeight: 280, overflowY: 'auto', border: '1px solid #2d2d44', borderRadius: 8, background: '#0f0f1a' }}>
                {itemsMarca
                  .filter(i => !busqEleccion || i.descripcion.toLowerCase().includes(busqEleccion.toLowerCase()) || i.codigo_bar.toLowerCase().includes(busqEleccion.toLowerCase()))
                  .map((item, idx) => (
                    <div key={item.codigo}
                      onClick={() => toggleItem(item.codigo)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 12,
                        padding: '10px 14px', cursor: 'pointer',
                        background: idx % 2 === 0 ? '#0f0f1a' : '#131320',
                        borderBottom: '1px solid #1a1a2e',
                      }}>
                      <div style={{
                        width: 18, height: 18, borderRadius: 4, flexShrink: 0,
                        background: itemsSelec[item.codigo] ? '#4caf50' : 'transparent',
                        border: `2px solid ${itemsSelec[item.codigo] ? '#4caf50' : '#444'}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        {itemsSelec[item.codigo] && <span style={{ color: '#fff', fontSize: 11, fontWeight: 'bold' }}>✓</span>}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ color: '#fff', fontSize: 13 }}>{item.descripcion}</div>
                        <div style={{ color: '#555', fontSize: 11 }}>{item.codigo_bar}</div>
                      </div>
                      <div style={{ color: '#aaa', fontSize: 12, textAlign: 'right' }}>
                        Stock: <strong style={{ color: '#4cc9f0' }}>{item.stock_sistema}</strong>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}

        <button style={s.botonGenerar} onClick={generarConteo} disabled={cargando}>
          {cargando ? 'Generando...' : '🚀 Iniciar conteo'}
        </button>
      </div>
    </div>
  );

  // ─── VISTA: CONTEO ───
  if (paso === 'conteo') return (
    <div>
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>📝 Conteo físico</h2>
          <p style={s.subtitulo}>{items.length} items · Ingresa la cantidad física de cada producto</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={s.botonHistorial} onClick={reiniciar}>← Volver</button>
          <button style={s.botonHistorial} onClick={imprimirConteo}>🖨️ Imprimir lista</button>
          <button style={{...s.botonGenerar, opacity: todoIngresado ? 1 : 0.5}} onClick={procesarReporte} disabled={!todoIngresado}>
            Ver reporte →
          </button>
        </div>
      </div>

      <div style={s.conteoTabla}>
        <div style={s.conteoHeader}>
          <span style={{ flex: 1 }}>CÓDIGO</span>
          <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
          <span style={{ flex: 1 }}>MARCA</span>
          <span style={{ width: 100, textAlign: 'right' }}>SISTEMA</span>
          <span style={{ width: 130, textAlign: 'center' }}>FÍSICO</span>
        </div>
        {items.map((item, i) => (
          <div key={i} style={{...s.conteoRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
            <span style={{ flex: 1, color: '#fff', fontSize: 14 }}>{item.codigo_bar || item.codigo}</span>
            <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{item.descripcion}</span>
            <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{item.marca}</span>
            <span style={{ width: 100, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>{item.stock_sistema}</span>
            <div style={{ width: 130, display: 'flex', justifyContent: 'center' }}>
              <input
                style={s.inputFisico}
                type="number"
                min="0"
                value={item.stock_fisico}
                onChange={e => actualizarFisico(i, e.target.value)}
                placeholder="0"
              />
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'right', marginTop: 16 }}>
        <span style={{ color: '#aaa', fontSize: 13 }}>
          {items.filter(i => i.stock_fisico !== '').length} / {items.length} ingresados
        </span>
      </div>
    </div>
  );

  // ─── VISTA: REPORTE ───
  if (paso === 'reporte') {
    const ok = items.filter(i => i.estado === 'ok');
    const faltantes = items.filter(i => i.estado === 'faltante');
    const excesos = items.filter(i => i.estado === 'exceso');

    return (
      <div>
        <div style={s.headerRow}>
          <div>
            <h2 style={s.titulo}>📊 Reporte de Auditoría</h2>
            <p style={s.subtitulo}>{items.length} items auditados</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={s.botonHistorial} onClick={reiniciar}>← Nueva auditoría</button>
            <button style={s.botonHistorial} onClick={() => imprimirReporte(null, items)}>🖨️ Imprimir</button>
            <button style={{...s.botonGenerar, opacity: auditoriaGuardada ? 0.5 : 1}}
              onClick={guardarAuditoria} disabled={!!auditoriaGuardada || cargando}>
              {auditoriaGuardada ? `✅ Guardada #${auditoriaGuardada}` : '💾 Guardar'}
            </button>
          </div>
        </div>

        {/* KPIs */}
        <div style={s.kpisRow}>
          <div style={{...s.kpiCard, borderTopColor: '#4caf50'}}>
            <div style={s.kpiValor}>{ok.length}</div>
            <div style={s.kpiLabel}>✅ Sin diferencia</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#e63946'}}>
            <div style={{...s.kpiValor, color: '#e63946'}}>{faltantes.length}</div>
            <div style={s.kpiLabel}>❌ Con faltante</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#ffc107'}}>
            <div style={{...s.kpiValor, color: '#ffc107'}}>{excesos.length}</div>
            <div style={s.kpiLabel}>⚠️ Con exceso</div>
          </div>
          <div style={{...s.kpiCard, borderTopColor: '#e63946'}}>
            <div style={{...s.kpiValor, color: '#e63946'}}>
              {faltantes.reduce((a, i) => a + Math.abs(i.diferencia), 0).toFixed(0)}
            </div>
            <div style={s.kpiLabel}>Unidades faltantes</div>
          </div>
        </div>

        {/* Tabla resultados */}
        <div style={s.conteoTabla}>
          <div style={s.conteoHeader}>
            <span style={{ flex: 1 }}>CÓDIGO</span>
            <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
            <span style={{ flex: 1 }}>MARCA</span>
            <span style={{ width: 90, textAlign: 'right' }}>SISTEMA</span>
            <span style={{ width: 90, textAlign: 'right' }}>FÍSICO</span>
            <span style={{ width: 90, textAlign: 'right' }}>DIFERENCIA</span>
            <span style={{ width: 110, textAlign: 'center' }}>ESTADO</span>
          </div>
          {[...faltantes, ...excesos, ...ok].map((item, i) => {
            const est = ESTADO_STYLE[item.estado];
            return (
              <div key={i} style={{...s.conteoRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
                <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{item.codigo_bar || item.codigo}</span>
                <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{item.descripcion}</span>
                <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{item.marca}</span>
                <span style={{ width: 90, textAlign: 'right', color: '#aaa' }}>{item.stock_sistema}</span>
                <span style={{ width: 90, textAlign: 'right', color: '#fff', fontWeight: 'bold' }}>{item.stock_fisico}</span>
                <span style={{ width: 90, textAlign: 'right', fontWeight: 'bold', color: item.diferencia < 0 ? '#e63946' : item.diferencia > 0 ? '#ffc107' : '#4caf50' }}>
                  {item.diferencia > 0 ? '+' : ''}{item.diferencia}
                </span>
                <span style={{ width: 110, textAlign: 'center' }}>
                  <span style={{ background: est.bg, color: est.color, borderRadius: 6, padding: '3px 8px', fontSize: 11, fontWeight: 'bold' }}>
                    {est.label}
                  </span>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // ─── VISTA: HISTORIAL ───
  if (paso === 'historial') return (
    <div>
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>📋 Historial de Auditorías</h2>
          <p style={s.subtitulo}>{historial.length} auditorías registradas</p>
        </div>
        <button style={s.botonHistorial} onClick={reiniciar}>← Volver</button>
      </div>

      {/* Modal detalle */}
      {auditoriaDetalle && (
        <div style={s.modalOverlay} onClick={() => setAuditoriaDetalle(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <span style={s.modalTitulo}>
                Auditoría #{auditoriaDetalle.auditoria.id} — {auditoriaDetalle.auditoria.fecha}
              </span>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={s.botonHistorial} onClick={() => imprimirReporte(auditoriaDetalle.auditoria, auditoriaDetalle.items)}>🖨️ Imprimir</button>
                <button style={s.modalCerrar} onClick={() => setAuditoriaDetalle(null)}>✕</button>
              </div>
            </div>
            <div style={s.modalBody}>
              <div style={s.kpisRow}>
                <div style={{...s.kpiCard, borderTopColor: '#4caf50'}}>
                  <div style={s.kpiValor}>{auditoriaDetalle.auditoria.items_ok}</div>
                  <div style={s.kpiLabel}>✅ OK</div>
                </div>
                <div style={{...s.kpiCard, borderTopColor: '#e63946'}}>
                  <div style={{...s.kpiValor, color: '#e63946'}}>{auditoriaDetalle.auditoria.items_faltante}</div>
                  <div style={s.kpiLabel}>❌ Faltante</div>
                </div>
                <div style={{...s.kpiCard, borderTopColor: '#ffc107'}}>
                  <div style={{...s.kpiValor, color: '#ffc107'}}>{auditoriaDetalle.auditoria.items_exceso}</div>
                  <div style={s.kpiLabel}>⚠️ Exceso</div>
                </div>
              </div>
              <div style={s.conteoTabla}>
                <div style={s.conteoHeader}>
                  <span style={{ flex: 1 }}>CÓDIGO</span>
                  <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
                  <span style={{ flex: 1 }}>MARCA</span>
                  <span style={{ width: 80, textAlign: 'right' }}>SISTEMA</span>
                  <span style={{ width: 80, textAlign: 'right' }}>FÍSICO</span>
                  <span style={{ width: 80, textAlign: 'right' }}>DIFF</span>
                  <span style={{ width: 100, textAlign: 'center' }}>ESTADO</span>
                </div>
                {auditoriaDetalle.items.map((item, i) => {
                  const est = ESTADO_STYLE[item.estado];
                  return (
                    <div key={i} style={{...s.conteoRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
                      <span style={{ flex: 1, color: '#555', fontSize: 11 }}>{item.codigo_bar || item.codigo}</span>
                      <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{item.descripcion}</span>
                      <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{item.marca}</span>
                      <span style={{ width: 80, textAlign: 'right', color: '#aaa' }}>{item.stock_sistema}</span>
                      <span style={{ width: 80, textAlign: 'right', color: '#fff', fontWeight: 'bold' }}>{item.stock_fisico}</span>
                      <span style={{ width: 80, textAlign: 'right', fontWeight: 'bold', color: item.diferencia < 0 ? '#e63946' : item.diferencia > 0 ? '#ffc107' : '#4caf50' }}>
                        {item.diferencia > 0 ? '+' : ''}{item.diferencia}
                      </span>
                      <span style={{ width: 100, textAlign: 'center' }}>
                        <span style={{ background: est.bg, color: est.color, borderRadius: 6, padding: '3px 8px', fontSize: 11, fontWeight: 'bold' }}>
                          {est.label}
                        </span>
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Barra de búsqueda por marca */}
      <div style={{ marginBottom: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          style={{ flex: 1, background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 8,
            color: '#fff', padding: '9px 14px', fontSize: 13 }}
          placeholder="🔍 Buscar por marca en el filtro..."
          value={busqHistorial}
          onChange={e => setBusqHistorial(e.target.value)}
        />
        {busqHistorial && (
          <button
            style={{ background: 'none', border: '1px solid #2d2d44', borderRadius: 8,
              color: '#555', padding: '9px 14px', cursor: 'pointer', fontSize: 13 }}
            onClick={() => setBusqHistorial('')}>✕ Limpiar</button>
        )}
        <span style={{ color: '#555', fontSize: 12, whiteSpace: 'nowrap' }}>
          {historial.filter(a => !busqHistorial || (a.filtro || '').toUpperCase().includes(busqHistorial.toUpperCase())).length} resultado(s)
        </span>
      </div>

      <div style={s.conteoTabla}>
        <div style={s.conteoHeader}>
          <span style={{ width: 60 }}>#</span>
          <span style={{ flex: 1 }}>Fecha</span>
          <span style={{ flex: 1 }}>Tipo</span>
          <span style={{ flex: 1 }}>Filtro</span>
          <span style={{ width: 100, textAlign: 'center' }}>Revisado</span>
          <span style={{ width: 70, textAlign: 'center' }}>Items</span>
          <span style={{ width: 70, textAlign: 'center', color: '#4caf50' }}>OK</span>
          <span style={{ width: 80, textAlign: 'center', color: '#e63946' }}>Faltante</span>
          <span style={{ width: 80, textAlign: 'center', color: '#ffc107' }}>Exceso</span>
          <span style={{ width: 80, textAlign: 'center' }}>Acción</span>
        </div>
        {historial
          .filter(a => !busqHistorial || (a.filtro || '').toUpperCase().includes(busqHistorial.toUpperCase()))
          .map((a, i) => (
          <div key={a.id} style={{...s.conteoRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}>
            <span style={{ width: 60, color: '#4cc9f0', fontWeight: 'bold' }}>#{a.id}</span>
            <span style={{ flex: 1, color: '#fff', fontSize: 13 }}>{a.fecha}</span>
            <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{a.tipo}</span>
            <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{a.filtro || '—'}</span>
            {/* Badge Revisado */}
            <span style={{ width: 100, textAlign: 'center' }}>
              {a.revisado ? (
                <button
                  style={{ background: '#1a3a2a', border: '1px solid #4caf50', borderRadius: 20,
                    color: '#4caf50', padding: '4px 12px', cursor: revisando === a.id ? 'not-allowed' : 'pointer',
                    fontSize: 11, fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                  disabled={revisando === a.id}
                  onClick={() => marcarRevisado(a.id, false)}
                  title="Click para desmarcar">
                  ✅ Revisado
                </button>
              ) : (
                <button
                  style={{ background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 20,
                    color: '#555', padding: '4px 12px', cursor: revisando === a.id ? 'not-allowed' : 'pointer',
                    fontSize: 11, fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                  disabled={revisando === a.id}
                  onClick={() => marcarRevisado(a.id, true)}
                  title="Marcar como revisado">
                  ○ Pendiente
                </button>
              )}
            </span>
            <span style={{ width: 70, textAlign: 'center', color: '#fff' }}>{a.total_items}</span>
            <span style={{ width: 70, textAlign: 'center', color: '#4caf50', fontWeight: 'bold' }}>{a.items_ok}</span>
            <span style={{ width: 80, textAlign: 'center', color: '#e63946', fontWeight: 'bold' }}>{a.items_faltante}</span>
            <span style={{ width: 80, textAlign: 'center', color: '#ffc107', fontWeight: 'bold' }}>{a.items_exceso}</span>
            <span style={{ width: 80, textAlign: 'center' }}>
              <button style={s.botonVer} onClick={() => verDetalle(a.id)}>Ver →</button>
            </span>
          </div>
        ))}
      </div>

      {/* ── Paginador ── */}
      {historialTotal > HIST_LIMIT && (() => {
        const totalPags = Math.ceil(historialTotal / HIST_LIMIT);
        const paginasVis = [];
        const desde = Math.max(1, historialPag - 2);
        const hasta  = Math.min(totalPags, desde + 4);
        for (let p = desde; p <= hasta; p++) paginasVis.push(p);
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', padding: '14px 16px',
            borderTop: '1px solid #2a2a3e', marginTop: 0,
            background: '#13131f', borderRadius: '0 0 12px 12px' }}>
            <span style={{ color: '#555', fontSize: 12 }}>
              {historialTotal} auditorías · página {historialPag} de {totalPags}
            </span>
            <div style={{ display: 'flex', gap: 4 }}>
              <button
                style={{ ...s.botonVer, opacity: historialPag === 1 ? 0.3 : 1 }}
                disabled={historialPag === 1}
                onClick={() => cargarHistorial(1)}>«</button>
              <button
                style={{ ...s.botonVer, opacity: historialPag === 1 ? 0.3 : 1 }}
                disabled={historialPag === 1}
                onClick={() => cargarHistorial(historialPag - 1)}>‹</button>
              {paginasVis.map(p => (
                <button key={p}
                  style={{
                    ...s.botonVer,
                    background: p === historialPag ? '#4cc9f0' : 'none',
                    color: p === historialPag ? '#000' : '#4cc9f0',
                    fontWeight: p === historialPag ? 700 : 400,
                    minWidth: 32,
                  }}
                  onClick={() => cargarHistorial(p)}>{p}</button>
              ))}
              <button
                style={{ ...s.botonVer, opacity: historialPag === totalPags ? 0.3 : 1 }}
                disabled={historialPag === totalPags}
                onClick={() => cargarHistorial(historialPag + 1)}>›</button>
              <button
                style={{ ...s.botonVer, opacity: historialPag === totalPags ? 0.3 : 1 }}
                disabled={historialPag === totalPags}
                onClick={() => cargarHistorial(totalPags)}>»</button>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

const s = {
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  titulo: { color: '#fff', marginBottom: 4 },
  subtitulo: { color: '#555', fontSize: 13 },
  botonHistorial: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  configCard: { background: '#1e1e2e', borderRadius: 12, padding: 28 },
  configTitulo: { color: '#fff', fontSize: 16, marginBottom: 24 },
  campo: { marginBottom: 20 },
  label: { display: 'block', color: '#888', fontSize: 12, marginBottom: 8 },
  tipoRow: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  tipoBton: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#aaa', padding: '10px 18px', cursor: 'pointer', fontSize: 13 },
  tipoBtonActivo: { border: '1px solid #4cc9f0', color: '#4cc9f0', background: '#1a2a3e' },
  cantidadRow: { display: 'flex', gap: 8 },
  select: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13, width: 260 },
  botonGenerar: { background: '#e63946', border: 'none', borderRadius: 8, color: '#fff', padding: '12px 28px', cursor: 'pointer', fontWeight: 'bold', fontSize: 14, marginTop: 8 },
  conteoTabla: { borderRadius: 12, overflow: 'hidden' },
  conteoHeader: { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  conteoRow: { display: 'flex', padding: '10px 16px', gap: 8, alignItems: 'center' },
  inputFisico: { width: 90, background: '#0f0f1a', border: '1px solid #4cc9f0', borderRadius: 6, color: '#fff', padding: '6px 10px', fontSize: 14, textAlign: 'center' },
  kpisRow: { display: 'flex', gap: 16, marginBottom: 24 },
  kpiCard: { background: '#1e1e2e', borderRadius: 12, padding: 20, flex: 1, borderTop: '3px solid #7209b7' },
  kpiValor: { color: '#fff', fontSize: 28, fontWeight: 'bold', marginBottom: 4 },
  kpiLabel: { color: '#aaa', fontSize: 12 },
  botonVer: { background: 'none', border: '1px solid #4cc9f0', borderRadius: 6, color: '#4cc9f0', padding: '4px 12px', cursor: 'pointer', fontSize: 12 },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.75)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  modal: { background: '#1a1a2e', borderRadius: 16, border: '1px solid #2d2d44', width: '95%', maxWidth: 1000, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 28px', borderBottom: '1px solid #2d2d44', flexShrink: 0 },
  modalTitulo: { color: '#fff', fontSize: 15, fontWeight: 'bold', flex: 1, marginRight: 16 },
  modalCerrar: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', fontSize: 16, cursor: 'pointer', padding: '6px 12px' },
  modalBody: { flex: 1, overflowY: 'auto', padding: 28 },  
};
// ═══════════════════════════════════════════════════════════════════
// WRAPPER — export default con tabs
// ═══════════════════════════════════════════════════════════════════
export default function Auditoria() {
  const [tabAuditoria, setTabAuditoria] = useState('conteo');
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 28 }}>
        {[
          { key: 'estado', label: '📊 Estado BOD. ESTACION' },
          { key: 'conteo', label: '🔍 Conteo Cíclico'       },
        ].map(t => (
          <button key={t.key}
            style={{
              padding: '8px 22px', borderRadius: 8, cursor: 'pointer',
              fontSize: 13, fontWeight: 'bold',
              background: tabAuditoria === t.key ? '#1a2a3e' : 'none',
              border: tabAuditoria === t.key ? '1px solid #4cc9f0' : '1px solid #2d2d44',
              color: tabAuditoria === t.key ? '#4cc9f0' : '#888',
            }}
            onClick={() => setTabAuditoria(t.key)}>
            {t.label}
          </button>
        ))}
      </div>
      {tabAuditoria === 'estado' && <EstadoBodega />}
      {tabAuditoria === 'conteo' && <ConteoAuditoria />}
    </div>
  );
}